import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISale } from "src/models/Stores/Sale.models";

interface SaleState {
  sales: ISale[];
  saleToEdit: ISale | null;
}

const initialState: SaleState = {
  sales: [],
  saleToEdit: null,
};

const saleSlice = createSlice({
  name: "Sale",
  initialState,
  reducers: {
    setSaleList: (state, action: PayloadAction<ISale[]>) => {
      state.sales = action.payload;
    },
    concatListSale: (state: SaleState, action: PayloadAction<ISale[]>) => {
      state.sales = [...state.sales.concat(action.payload)];
    },
    setSaleToEdit: (state, action: PayloadAction<ISale | null>) => {
      state.saleToEdit = action.payload;
    },
    setURLToSaleToEdit: (
      state,
      action: PayloadAction<string | null>
    ) => {
        if (state.saleToEdit)
        state.saleToEdit.url = action.payload;
    },
    addSale: (state, action: PayloadAction<ISale>) => {
      state.sales.push(action.payload);
    },
    updateSale: (state, action: PayloadAction<ISale>) => {
      let itemIndex = state.sales.findIndex(
        item => item.saleId === action.payload.saleId
      );
      if (itemIndex !== -1) state.sales[itemIndex] = action.payload;
    },
    deleteSale: (state, action: PayloadAction<number>) => {
      const newArray = state.sales.filter(
        item => item.saleId !== action.payload
      );
      state.sales = newArray;
    },
  },
});

export const {
  setSaleList,
  concatListSale,
  setSaleToEdit,
  setURLToSaleToEdit,
  addSale,
  updateSale,
  deleteSale,
} = saleSlice.actions;

export default saleSlice.reducer;
